import { FormikErrors } from 'formik'
import { useModalControl } from '../../hooks/useModalControl'
import { Tag } from '../../redux-toolkits/products/products.type'
import { CreateProductValues } from '../../redux-toolkits/products/products.type'
import { ActionChip } from '../cards/actionChip'
import { EditInput } from '../inputs/editInput'
import { SelectTagsModal } from '../modal/app_modals/selectTagsModal'
import { HeaderSubheader } from '../typography/HeaderSubheader'

export const ManageProductTags = ({
  values,
  setFieldValue,
  typeTitle,
}: {
  values: CreateProductValues
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean,
  ) => Promise<void> | Promise<FormikErrors<CreateProductValues>>
  typeTitle: string
}) => {
  const { handleModalOpen, setModalOpen, modal, modalOpen, handleModalClose } =
    useModalControl()

  return (
    <div className="flex flex-col gap-6 pb-10 border-b border-divider-gray">
      <HeaderSubheader
        title={`${typeTitle} Tags`}
        text={`Specify ${typeTitle} tags`}
        className="w-full md:w-fit"
      />

      <EditInput
        title={`Tags`}
        value={undefined}
        onEditClick={() => {
          handleModalOpen('selectTagsModal')
        }}
        errors={undefined}
        onCancel={() => {}}
        onEditSave={() => {}}
        editing={false}
        className={'col-span-full'}
      >
        {() => {
          return (
            <div className="flex flex-row gap-4 items-center flex-wrap">
              {values.tags.map((tag: Tag, idx) => {
                const key = `tag-${idx}`
                return <ActionChip key={key} name={tag.name} icon={tag.icon} />
              })}
            </div>
          )
        }}
      </EditInput>

      <SelectTagsModal
        open={modalOpen && modal === 'selectTagsModal'}
        setOpen={setModalOpen}
        onCloseCallback={() => {
          handleModalClose()
        }}
        onSuccessCallback={(tags) => {
          setFieldValue('tags', tags)
          handleModalClose()
        }}
        selectedTags={values.tags}
      />
    </div>
  )
}
